import * as actions from '../actionTypes'
const initialState = [];

const subjectInstancesReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.DELETE_SUBJECT_INSTANCE:
            return state.filter((subjectInstance) => subjectInstance._id !== action.payload);
        case actions.SET_SUBJECT_INSTANCES:
            return action.payload;
        case actions.ADD_SUBJECT_INSTANCE:
            return [...state, action.payload];
        case actions.UPDATE_SUBJECT_INSTANCE: {
            return state.map((subjectInstance) => subjectInstance._id === action.payload._id ? action.payload : subjectInstance);
        }
        case actions.GET_ATTENDANCE_CODE: {
            return state.map((subjectInstance) => subjectInstance._id === action.payload.subjectInstance._id ? { ...subjectInstance, code: action.payload.code.code } : subjectInstance);
        }
        default:
            return state;
    }
};
export default subjectInstancesReducer;

